function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0391 14.293L11.043 3.29491C10.7398 3.10955 10.3928 3.0083 10.0376 3.00158C9.68232 2.99486 9.3317 3.0829 9.02178 3.25666C8.71186 3.43042 8.45383 3.68361 8.27425 3.99019C8.09466 4.29677 8 4.64566 8 5.00097V26.999C8.00029 27.3542 8.09513 27.7029 8.27479 28.0093C8.45445 28.3157 8.71244 28.5688 9.02226 28.7425C9.33208 28.9162 9.68255 29.0043 10.0377 28.9977C10.3928 28.9911 10.7398 28.8901 11.043 28.7051L29.0391 17.707C29.3314 17.5283 29.5729 17.2774 29.7405 16.9785C29.9081 16.6796 29.9961 16.3427 29.9961 16C29.9961 15.6573 29.9081 15.3204 29.7405 15.0215C29.5729 14.7226 29.3314 14.4717 29.0391 14.293Z",
  fill: "#78716C"
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.67f91053.svg";
export { ForwardRef as ReactComponent };